import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import Icon, { ICON_TYPE } from "components/Icon";
import { colors } from "style";
import { StyledTag } from "components/Tags";

/**
 * TagOptional
 */
const TagOptional = (props) => (
  <StyledTag css={styles.container}>
    <Icon type={ICON_TYPE.dottedCircle} color="inherit" {...props} />
    <FormattedMessage id="Global.Optional" />
  </StyledTag>
);

const styles = {
  container: css`
    background: ${colors.grayAnatomyLight4};
    color: ${colors.grayAnatomyBase};
    gap: 0.5rem;
  `,
};

export default TagOptional;
